import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { ApiUserAdmin, endpoints_localAdmin, endpoints_userAdmin } from "src/app/api/userAdminApi";

const api = new ApiUserAdmin();

export const getLocalsAdmin = createAsyncThunk(
  "localApp/admin/getAllLocalAdmin",
  async (params, { getState }) => {
    const data = await api.get(endpoints_localAdmin.LOCAL);
    return { data };
  }
);

export const getLocalAdmin = createAsyncThunk(
  "localApp/admin/getLocalAdmin",
  async (id, { dispatch, getState }) => {
    try {
      const data = await api.get(endpoints_localAdmin.LOCAL, id);
      return { data };
    } catch (error) {
      history.push({ pathname: `/localAdmin` });
      return null;
    }
  }
);

export const addLocalAdmin = createAsyncThunk(
  "localApp/admin/addLocalAdmin",
  async (localAdmin, { dispatch, getState }) => {
    localAdmin.active = true;
    const data = await api.post(endpoints_localAdmin.LOCAL, localAdmin);
    return { data };
  }
);

export const updateLocalAdmin = createAsyncThunk(
  "localApp/admin/updateLocalAdmin",
  async (localAdmin, { dispatch, getState }) => {
    try {
      const data = await api.put(
        endpoints_localAdmin.LOCAL,
        localAdmin.id,
        localAdmin
      );
      return { data };
    } catch (error) {
      return error;
    }
  }
);

export const removeLocalAdmin = createAsyncThunk(
  "localApp/admin/removeLocalAdmin",
  async (localAdmin, { dispatch, getState }) => {
    try {
      const data = {
        id: localAdmin.id,
        fantasy_name: localAdmin.name,
        num_auth_sani: localAdmin.num_auth_sani,
        company_name: localAdmin.company_name,
        rut: localAdmin.rut,
        id_emp_admin: localAdmin.id_emp_admin,
        active: false,
        premium: localAdmin.premium,
      };
      const response = await api.put(
        endpoints_localAdmin.LOCAL,
        localAdmin.id,
        data
      );
      return response.id;
    } catch (error) {
      return error;
    }
  }
);

const localAdapter = createEntityAdapter();

const localSlice = createSlice({
  name: "localApp/admin",
  initialState: localAdapter.getInitialState({
    selectedLocalId: null,
  }),
  reducers: {
    clearSelectedLocal: (state) => {
      state.selectedLocalId = null;
    },
    setSelectedLocal: (state, action) => {
      state.selectedLocalId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocalsAdmin.fulfilled, (state, action) => {
        localAdapter.setAll(state, action.payload.data);
      })
      .addCase(addLocalAdmin.fulfilled, (state, action) => {
        localAdapter.addOne(state, action.payload.data);
      })
      .addCase(getLocalAdmin.fulfilled, (state, action) => {
        localAdapter.upsertOne(state, action.payload.data);
      })
      .addCase(removeLocalAdmin.fulfilled, (state, action) => {
        localAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateLocalAdmin.fulfilled, (state, action) => {
        localAdapter.upsertOne(state, action.payload.data);
      });
  },
});

export const { clearSelectedLocal, setSelectedLocal } = localSlice.actions;

// Selectores generados automáticamente
export const { selectAll: selectLocal, selectById: selectLocalById } = 
  localAdapter.getSelectors((state) => state.localApp.admin);

export const selectSelectedLocal = (state) => {
  const id = state.localApp.admin.selectedLocalId;
  return id ? selectLocalById(state, id) : null;
};

export default localSlice.reducer;
